"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require("../");
class PursuitModel extends _1.PipelineModel {
    constructor() {
        super(...arguments);
        this.instanceType = 'Pursuit';
    }
    get salesforceFieldMap() {
        return {
            _id: 'Id',
            brokerProposedPrice: 'McLabs2__Broker_Proposed_Price__c',
            clientCompanyId: 'McLabs2__Client_Company__c',
            clientContactId: 'McLabs2__Client__c',
            commissionAmount: 'McLabs2__Commission__c',
            listProbability: 'McLabs2__List_Probability__c',
            name: 'Name',
            notes: 'McLabs2__Notes__c',
            ownerId: 'OwnerId',
            propertyId: 'McLabs2__Property__c',
            pursuitDeliveryDate: 'McLabs2__Date_of_Proposal_Appointment__c',
            recordTypeId: 'RecordTypeId',
            sellerPriceExpectation: 'McLabs2__Seller_Price_Expectation__c',
            sellProbability: 'McLabs2__Sell_Probability__c',
            status: 'McLabs2__Status__c'
        };
    }
    transformFromSalesforce(sfPursuit) {
        super.transformFromSalesforce(sfPursuit);
        this.type = sfPursuit.RecordType ? sfPursuit.RecordType.Name : undefined;
    }
    get price() {
        return this.brokerProposedPrice;
    }
    // Probability variable deleted; replaced with following getter
    // (Was formerly mapped to incorrect Salesforce field in salesforceFieldMap)
    get probability() {
        // Backward-compatibility check:
        // Old users will have the correct field value saved in sellProbability
        // We return that value if the new listProbability is as yet undefined
        return this.listProbability || this.sellProbability;
    }
    // Probability variable deleted; replaced with following setter
    // (Was formerly mapped to incorrect Salesforce field in salesforceFieldMap)
    set probability(newProbability) {
        // Going forward we only assign to listProbability
        this.listProbability = newProbability;
    }
}
PursuitModel.STATUSES = {
    DEAD: 'Dead',
    NOT_WON: 'Not Won',
    PRESENTED: 'Presented',
    WAITING_FOR_BOOKS_AND_RECORDS: 'Waiting for Books & Records',
    WAITING_TO_BE_PRESENTED: 'Waiting to be Presented',
    WON: 'Won',
    WORKING: 'Working'
};
PursuitModel.TYPES = {
    BUYER_REPRESENTATION: 'Buyer Representation',
    LANDLORD_REPRESENTATION: 'Landlord Representation',
    SELLER_REPRESENTATION: 'Seller Representation',
    TENANT_REPRESENTATION: 'Tenant Representation'
};
exports.PursuitModel = PursuitModel;
//# sourceMappingURL=pursuit.model.js.map